export function initCookieConsent() {
  // A failed CDN request must not prevent other site interactions starting.
  if (!window.silktideConsentManager) return;

  window.silktideConsentManager.init({
    backdrop: { show: true },
    icon: { position: 'bottomLeft' },
    prompt: { position: 'bottomRight' },
    consentTypes: [
      {
        id: 'essential',
        label: 'Essential',
        description: '<p>These cookies are necessary for the website to function properly and cannot be switched off. They help with things like logging in and setting your privacy preferences.</p>',
        required: true,
      },
      {
        id: 'analytics',
        label: 'Analytics',
        description: '<p>These cookies help us improve the site by tracking which pages are most popular and how visitors move around the site.</p>',
        required: false,
        defaultValue: true,
        gtag: 'analytics_storage',
      },
      {
        id: 'marketing',
        label: 'Marketing',
        description: '<p>These cookies are used by us and our advertising partners to show you relevant ads on this site and elsewhere, and to measure how those campaigns perform.</p>',
        required: false,
        gtag: ['ad_storage', 'ad_user_data', 'ad_personalization'],
      },
    ],
    text: {
      prompt: {
        description: '<p>We use cookies on our site to enhance your user experience, provide personalized content, and analyze our traffic.</p>',
        acceptAllButtonText: 'Accept all',
        acceptAllButtonAccessibleLabel: 'Accept all cookies',
        rejectNonEssentialButtonText: 'Reject non-essential',
        rejectNonEssentialButtonAccessibleLabel: 'Reject all non-essential cookies',
        preferencesButtonText: 'Preferences',
        preferencesButtonAccessibleLabel: 'Toggle preferences',
      },
      preferences: {
        title: 'Customize your cookie preferences',
        description: '<p>We respect your right to privacy. You can choose not to allow some types of cookies. Your cookie preferences will apply across our website.</p>',
        saveButtonText: 'Save and close',
        saveButtonAccessibleLabel: 'Save your cookie preferences',
        creditLinkText: 'Get this banner for free',
        creditLinkAccessibleLabel: 'Get this banner for free',
      },
    },
  });
}
